module.exports = __webpack_public_path__ + "static/media/school.33129fb8.webp";